export default __webpack_public_path__ + "static/media/prodivec-logo.51078a0d.svg";